import { trackEvent } from "@amplio-common/analytics";
import { selectGroups, selectCurrentGroup } from "@app/routes/studentGroup/store/studentGroupSlice";
import { selectActiveStudents } from "@app/routes/studentsV2/store/studentSlice";

const getNumOfStudentsWithGroups = (state) => {
  const studentsWithGroups = new Set();
  selectGroups(state).forEach(g => g.students.forEach(s => studentsWithGroups.add(s)));
  return studentsWithGroups.size;
};

const getCurrentGroupProperties = (state) => {
  const currentGroup = selectCurrentGroup(state);
  const groupSpecificData = currentGroup ? { num_students_in_group: currentGroup.students.length, group_id: currentGroup.id } : {};
  return groupSpecificData;
};

const getGroupDefaultProperties = (state) => {
  const numOfGroups = selectGroups(state).length;
  const numOfGroupStudents = getNumOfStudentsWithGroups(state);
  const numOfAllStudents = selectActiveStudents(state).length;

  return {
    num_groups_set: numOfGroups,
    num_grouped_students: numOfGroupStudents,
    num_total_students: numOfAllStudents,
  };
};

export const trackGroupEvent = (eventName, state, additionalParams = {}, callback = null, stateForGroup = null) =>
  setTimeout(() => {
    try {
      const groupState = stateForGroup || state;
      const groupSpecificData = ["enter_student_group_tab", "exit_student_group_tab"].includes(eventName) ? {} : getCurrentGroupProperties(groupState);
      trackEvent(eventName, { ...getGroupDefaultProperties(state), ...groupSpecificData, ...additionalParams });
      callback?.();
    } catch (e) {
      console.error(`failed to send student group analytics ${eventName}: ${e}`);
    }
  }, 1);
